import { render } from "./NavLinks.vue?vue&type=template&id=3a5b51df&scoped=true"
import script from "./NavLinks.vue?vue&type=script&lang=js"
export * from "./NavLinks.vue?vue&type=script&lang=js"

import "./NavLinks.vue?vue&type=style&index=0&id=3a5b51df&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a5b51df"]])

export default __exports__